import { filterStyles } from "@insite/content-library/Widgets/OrderApprovalList/OrderApprovalListFilter";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

filterStyles.fromGridItem = {
    width: 6,
    css: css`
        > div {
            max-width: 100%;
            flex-basis: 100%;
            > div[class^="FormFieldStyle"] {
                padding-right: 0;
            }
        }
    `,
};
filterStyles.toGridItem = {
    width: 6,
    css: css`
        > div {
            max-width: 100%;
            flex-basis: 100%;
            > div[class^="FormFieldStyle"] {
                padding-right: 0;
            }
        }
    `,
};
filterStyles.shipToGridItem = {
    width: [12, 12, 6, 6, 4],
};
filterStyles.orderNumberGridItem = {
    width: [12, 12, 6, 6, 2],
};
filterStyles.datesContainer = {
    gap: 0,
};
filterStyles.datesGridItem = {
    width: [12, 12, 12, 12, 6],
    css: css`
        padding: 0;
    `,
};
filterStyles.datesContainer = {
    css: css`
        > div[class^="GridOffset"] {
            width: 100%;
            margin: 0;
        }
    `,
};

filterStyles.orderTotalGridItem = {
    width: 12,
    css: css`
        padding: 0;
    `,
};
filterStyles.orderTotalAmountGridItem = {
    width: [6, 6, 6, 6, 2],
};
filterStyles.orderTotalOperatorGridItem = {
    width: [6, 6, 6, 6, 2],
};
filterStyles.orderTotalFieldset = {
    css: css`
        border: none;
        margin: 0;
        padding: 0;
        width: 100%;
        > div[class^="GridWrapper"] {
            > div[class^="GridOffset"] {
                width: 100%;
                margin: 0;
                > div[class^="GridItemStyle"] {
                    padding: 15px;
                }
            }
        }
    `,
};
filterStyles.clearFiltersButton = {
    variant: "secondary",
    css: css`
        margin-right: 0;
    `,
};
